module.exports = __webpack_public_path__ + "S-T2.jpg?1a1d7d47134f381717ccd4918b635ed2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S-T2.jpg
// module id = 326
// module chunks = 0